import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import 'katex/dist/katex.min.css';
// Internal dependencies
import { UserContext } from '../auth';
import { InputAction } from './InputAction';
import { ToolAction } from './ToolAction';
import { PromptAction } from './PromptAction';
import { ACTION_TYPES } from './constants';
import { WorkflowActionHeader } from './WorkflowActionHeader';
/**
 * Workflow Action component
 * @param props Props
 * @returns Workflow Action component
 */
export const WorkflowAction = function ({ action, actionIdx, formik, }) {
    // Get user credential
    const user = useContext(UserContext);
    // Get translation function
    const { t, i18n } = useTranslation();
    /**
     * Get action body
     * @returns Action component
     */
    const getActionBody = () => {
        const /** Action type */ actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                return (_jsx(InputAction, { action: action, actionIdx: actionIdx, formik: formik }));
                break;
            case ACTION_TYPES.TOOL:
                return (_jsx(ToolAction, { action: action }));
                break;
            case ACTION_TYPES.PROMPT:
                return (_jsx(PromptAction, { action: action }));
                break;
            default:
                return (_jsx(PromptAction, { action: action }));
        }
    };
    /**
     * Is this action got any error
     * @returns True/false
     */
    const isError = () => {
        var _a, _b;
        const /** Workflow Action type */ actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                const inputErrors = ((_a = formik === null || formik === void 0 ? void 0 : formik.errors) === null || _a === void 0 ? void 0 : _a.actions) && ((_b = formik.errors.actions[actionIdx]) === null || _b === void 0 ? void 0 : _b.inputs) && formik.errors.actions[actionIdx].inputs.map((input) => (Boolean(input === null || input === void 0 ? void 0 : input.value)));
                return (inputErrors || []).findIndex((inputError) => (inputError === true)) > -1 ? true : false;
                break;
        }
        return false;
    };
    return (_jsxs(Accordion
    //elevation={0}
    // expanded={action?.type === ACTION_TYPES.INPUT ? true : undefined}
    , Object.assign({ 
        //elevation={0}
        // expanded={action?.type === ACTION_TYPES.INPUT ? true : undefined}
        defaultExpanded: (action === null || action === void 0 ? void 0 : action.type) === ACTION_TYPES.INPUT ? true : false, sx: {
            padding: '1rem',
            cursor: 'default',
            borderRadius: '12px!important',
            boxSizing: 'border-box',
            border: '1px solid',
            borderColor: isError() ? '#ff0000' : 'greyLight.main',
            boxShadow: 'none',
            backgroundColor: 'whiteDark.main',
            width: '100%',
            '& .MuiAccordionSummary-content': {
                margin: '0!important',
            },
            '& h1.MuiTypography-root': {
                padding: '0!important',
            },
            '& .MuiButtonBase-root.MuiAccordionSummary-root': {
                minHeight: '0',
            },
        }, id: "workflow-action-accordion" }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ExpandMore, { sx: { color: 'black.main' } }), "aria-controls": "panel1a-content", id: "panel1a-header", sx: {
                    '&': {
                        cursor: 'default',
                        zIndex: '2',
                        backgroundColor: 'transparent',
                        margin: '0',
                        padding: '0',
                    },
                    '& .MuiAccordionSummary-content': {
                        overflow: 'hidden',
                    },
                } }, { children: _jsx(WorkflowActionHeader, { action: action }) })), _jsx(AccordionDetails, Object.assign({ sx: {
                    padding: '1.5rem 0 0',
                    backgroundColor: 'transparent',
                    height: '100%',
                    boxSizing: 'border-box',
                } }, { children: getActionBody() }))] })));
};
